<button
  id="btnClose"
  type="button"
  class="btn-close close"
  aria-label="Close"
  (click)="bsModalRef.hide()"
>
  <span aria-hidden="true" class="visually-hidden">&times;</span>
</button>
<div id="content-section" class="text-center">
  <span aria-hidden="true" class="visually-hidden">&times;</span>
  <p class="fs-1 lh-sm">{{ text }}</p>
  <button class="btn btn-primary" (click)="onSelect()">{{ btnText }}</button>
</div>
<!--
<div id="image-section">
  <img src="{{ img }}" alt="{{ altText }}" class="img-fluid w-100" />
</div>
-->
